export enum DealingType {
    Credit = 1,
    Cash = 2,
    Both =3
}